import * as React from 'react'
import { memo } from 'react'
const SvgDrag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
  >
    <path d="m8 16-2.945-2.945.44-.44 2.2 2.2V8.31H1.19l2.2 2.2-.44.44L0 8l2.945-2.945.44.44-2.2 2.2H7.69V1.19l-2.2 2.2-.44-.44L8 0l2.945 2.945-.44.44-2.2-2.2V7.69h6.505l-2.2-2.2.44-.44L16 8l-2.945 2.945-.44-.44 2.2-2.2H8.31v6.505l2.2-2.2.44.44Z" />
  </svg>
)
const Memo = memo(SvgDrag)
export default Memo
